import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Box } from "@material-ui/core";
import EditText from "../../components/EditText";
import Submit from "../../components/Submit";
import { useTranslation } from "react-i18next";

const validationSchema = Yup.object().shape({
  hw_id: Yup.string().required("HW id is required"),
  serial_id: Yup.string().required("Serial id is required"),
  hmi_version: Yup.string().required("HMI Version is required"),
  software_version: Yup.string().required("Software Version is required"),
  model_type: Yup.string().required("Model Type is required"),
  name: Yup.string().required("Name is required"),
  //plant: Yup.string().required(),
});

const EditEklokForm = ({ onSubmit = () => {}, initialValues }) => {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(props) => {
        console.log("props: ", props);

        return (
          <form onSubmit={props.handleSubmit}>
            <EditText {...props} label={t("edit_eklok.name")} name="name" />
            <EditText
              {...props}
              disabled={true}
              label={t("edit_eklok.serial_id")}
              name="serial_id"
            />
            <EditText
              {...props}
              disabled={true}
              label={t("edit_eklok.hw_id")}
              name="hw_id"
            />
            <EditText
              {...props}
              disabled={true}
              label={t("edit_eklok.hmi_version")}
              name="hmi_version"
            />
            <EditText
              {...props}
              disabled={true}
              label={t("edit_eklok.software_version")}
              name="software_version"
            />
            <EditText
              {...props}
              disabled={true}
              label={t("edit_eklok.model_type")}
              name="model_type"
            />
            <Box my={2}>
              <Submit {...props} title={t("edit_eklok.save")} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
};

export default EditEklokForm;
